import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";

import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header} from "../../components";
import BaseURL from "../../assets/utils/baseUrl";

function Bayar() {
  useDocumentTitle("Cek Tunggakan PBB - BAPENDA BEKASI");

  // ... (state dan useEffect laporan tetap ada jika masih dibutuhkan di halaman lain)

  return (
    <div className="page">
      <Header active="Bayar" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Bayar PBB" />
        

          {/* Menampilkan Website Luar di dalam Iframe */}
          <div style={{ width: '100%', overflow: 'hidden', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <iframe
              src="https://bapenda.bekasikota.go.id/tcmpos/"
              title="Bayar PBB"
              style={{
                width: '100%',
                height: '800px', // Atur tinggi sesuai kebutuhan
                border: 'none'
              }}
              allowFullScreen
            ></iframe>
          </div>

        </section>
 
      </main>

      <Footer />
    </div>
  );
}

export default Bayar;